import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import ROUTES from '@src/constants/route';
import { Button } from '@mui/material';
import CrownImg from '@src/assets/images/crown.png';
import usePaywallTracking from '@src/hooks/usePaywallTracking';
import { MOE_PAYWALL_CTA, MOE_PAYWALL_TYPE } from '@src/constants/moengage';

const ExpiredPackageAlert = ({ open, onClose }) => {
  const { t } = useTranslation();

  const history = useHistory();

  const { trackCta } = usePaywallTracking({
    paywallType: MOE_PAYWALL_TYPE.EXPIRED_PACKAGE,
  });

  const handleUpgradeNow = () => {
    trackCta(MOE_PAYWALL_CTA.UPGRADE);
    history.push(ROUTES.PAYMENT);
  };

  const renderUpgradeButton = () => (
    <Button variant="contained" onClick={handleUpgradeNow}>
      {t('buyNow')}
    </Button>
  );

  return (
    <NotificationDialogV4
      image={CrownImg}
      title={t('expiredPackage')}
      description={t('expiredPackageDesc')}
      actionComponent={renderUpgradeButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default ExpiredPackageAlert;
